import { Component, Input } from '@angular/core';

@Component({
  selector: 'fgbcl-linear-progress-bar',
  templateUrl: './linear-progress-bar.component.html',
  styleUrl: './linear-progress-bar.component.scss',
})
export class LinearProgressBarComponent {
  @Input() progress: number = 0;
  @Input() backgroundClass: string;
  @Input() disableAnimation!: boolean;
}
